import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'direct_deposit_into_bank_account'

export const dataPointDefinition = {
  retracedId: 'direct_deposit_into_bank_account',
  name: 'Direct deposit into a bank account',
  description:
    "\"Direct deposit into a bank account\" refers to workers being paid their wages via electronic transfer from the payer's bank account (i.e. the facility's) into the recipient's bank account (i.e. the worker's).",
  meta: {
    slcpMeta: {
      key: 'wb-15-3x',
      number: 'WB-WAGE-100-1',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wb-15-3x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 34980,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
